import { Directive, ElementRef, Input, SimpleChanges } from '@angular/core';
import { ColorGenerator } from './color-generator';

@Directive({
  selector: '[appTextAvatar]',
  providers: [ColorGenerator],
})
export class TextAvatarDirective {

  constructor(private element: ElementRef, private colorGenerator: ColorGenerator) { }

  @Input() text: string;
  @Input() color: string;
  // tslint:disable-next-line:use-life-cycle-interface
  ngOnChanges(changes: SimpleChanges) {
    const text = changes.text ? changes.text.currentValue : null;
    const color = changes.color ? changes.color.currentValue : null;
    this.element.nativeElement.setAttribute('value', this.extractFirstCharacter(text));
    this.element.nativeElement.style.backgroundColor = this.backgroundColorHexString(color, text);
  }

  private extractFirstCharacter(text: string): string {    
    return text.charAt(0) || '';
  }

  private backgroundColorHexString(color: string, text: string): string {
    return color || this.colorGenerator.getColor(this.extractFirstCharacter(text));
  }
}